import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves the latest spot currency data from the API gateway (Redis-backed cache server-side).
 *
 * @param {object} _this - The context object containing necessary data.
 * @param {number|null} [pk=null] - The primary key for the currency (optional).
 * @returns {Promise<object>} A promise resolving to the spot currency data.
 */
export function getSpotCurrency(_this, pk = null) {
  return gatewayService.currencies.intradayHistory({
    format: "json",
    last: 1,
    currency: pk == null ? _this.currencyNumber : pk,
  });
}
